import { render, staticRenderFns } from "./FormV1.vue?vue&type=template&id=819a9b58&"
import script from "./FormV1.vue?vue&type=script&lang=js&"
export * from "./FormV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports